module.exports = __webpack_public_path__ + "img/3198836.jpg";